import React from 'react';
import { useState, useEffect } from 'react';
import fetchJsonp from 'fetch-jsonp'; // Context

import { useFiltersContext } from '@accrosoft-ltd/vf-careers-site-theme/src/context/FiltersContext';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SmartFeedFilters = function SmartFeedFilters(_ref) {
  var siteConfig = _ref.siteConfig,
      group = _ref.group,
      groupOrIdParam = _ref.groupOrIdParam,
      apiKey = _ref.apiKey;

  var _useFiltersContext = useFiltersContext(),
      _useFiltersContext$fi = _useFiltersContext.filtersState,
      options = _useFiltersContext$fi.options,
      keywords = _useFiltersContext$fi.keywords,
      autocomplete = _useFiltersContext$fi.autocomplete,
      filters = _useFiltersContext$fi.filters,
      loading = _useFiltersContext.loading,
      setLoading = _useFiltersContext.setLoading,
      fetchOptions = _useFiltersContext.fetchOptions,
      onKeywordsChange = _useFiltersContext.onKeywordsChange,
      onSelectionChange = _useFiltersContext.onSelectionChange,
      onLocationSelected = _useFiltersContext.onLocationSelected,
      onLocationChange = _useFiltersContext.onLocationChange,
      resetLocation = _useFiltersContext.resetLocation,
      resetFilters = _useFiltersContext.resetFilters;

  var _useState = useState([]),
      autoCompleteFilter = _useState[0],
      setAutoCompleteFilter = _useState[1];

  var _useState2 = useState(true),
      autocompleteListHide = _useState2[0],
      setAutocompleteListHide = _useState2[1];

  useEffect(function () {
    if (siteConfig.showAdvancedFilters === true) {
      var optionNames = [];

      if (group === true) {
        optionNames = [{
          func: 'GetRegionListByGroup',
          name: 'Regions',
          key: 'regions'
        }, {
          func: 'GetCategoryListByGroup',
          name: 'Categories',
          key: 'categories'
        }, {
          func: 'GetJobTypeListByGroup',
          name: 'Job Types',
          key: 'jobTypes'
        }, {
          func: 'GetPostingTypesListByGroup',
          name: 'Posting Types',
          key: 'postingTypes'
        }, {
          func: 'GetIndustryListByGroup',
          name: 'Industries',
          key: 'industries'
        }, {
          func: 'GetLocationListByGroup',
          name: 'Locations',
          key: 'locations'
        }];
      } else {
        optionNames = [{
          func: 'GetRegions',
          name: 'Regions',
          key: 'regions'
        }, {
          func: 'GetCategories',
          name: 'Categories',
          key: 'categories'
        }, {
          func: 'GetJobTypes',
          name: 'Job Types',
          key: 'jobTypes'
        }, {
          func: 'GetPostingTypes',
          name: 'Posting Types',
          key: 'postingTypes'
        }, {
          func: 'GetIndustries',
          name: 'Industries',
          key: 'industries'
        }, {
          func: 'GetLocations',
          name: 'Locations',
          key: 'locations'
        }];
      }

      fetchOptions(siteConfig.sfAPIEndpoint, groupOrIdParam, apiKey, optionNames);
    }
  }, []);

  var autocompleteSearchChange = function autocompleteSearchChange(e) {
    setAutocompleteListHide(false);
    var val = e.target.value;
    onLocationChange(val);

    if (val.length > 2) {
      // Do api call to get key
      fetchJsonp(siteConfig.sfAPIEndpoint + '/CareerPage/GetLocationAPIKey?id=' + apiKey, {
        timeout: 15000
      }).then(function (response) {
        return response.json();
      }).then(function (geoKey) {
        // Do api call to get locs
        fetch(siteConfig.geocodingEndpoint + '/api/V2/exact/?apikey=' + geoKey.key + '&search=' + encodeURIComponent(val)).then(function (res) {
          return res.json();
        }).then(function (result) {
          setAutoCompleteFilter(result.locationResults);
        });
      });
    } else {
      setAutocompleteListHide(true);
    }
  };

  var getCurrentLocation = function getCurrentLocation() {
    if (navigator.geolocation) {
      var errorPosition = function errorPosition(err) {
        console.error("We couldn't retrieve your location", err);
      };

      var showPosition = function showPosition(position) {
        setAutocompleteListHide(true);
        onLocationSelected({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          distance: 15,
          displayName: 'Current Location'
        });
      };

      var optionsPosition = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      navigator.geolocation.getCurrentPosition(showPosition, errorPosition, optionsPosition);
    } else {
      console.warn('Geolocation is not supported by your browser');
    }
  };

  var renderFilter = function renderFilter(label, key, option) {
    if (label === 'Keyword Search') {
      return /*#__PURE__*/_jsxs("div", {
        className: "vf-filter",
        children: [/*#__PURE__*/_jsxs("label", {
          htmlFor: "keywords",
          children: [label, ": "]
        }), /*#__PURE__*/_jsxs("div", {
          className: "vf-filter-wrap",
          children: [/*#__PURE__*/_jsx("input", {
            value: keywords,
            onChange: onKeywordsChange,
            className: "VF-form-control onchange-search form-control",
            id: "keywords",
            name: key,
            placeholder: "Enter keywords",
            type: "text"
          }), /*#__PURE__*/_jsx("div", {
            className: "filter-icon",
            children: /*#__PURE__*/_jsx("span", {
              onClick: function onClick() {
                return onKeywordsChange({
                  target: {
                    value: ''
                  }
                });
              },
              className: "fas fa-times right-icon " + (!keywords && 'hidden') + " clear-icon",
              title: "Clear"
            })
          })]
        })]
      });
    } else if (label === 'Location Search') {
      return /*#__PURE__*/_jsxs("div", {
        className: "vf-filter",
        children: [/*#__PURE__*/_jsxs("label", {
          htmlFor: 'select-' + label,
          children: [label, ": "]
        }), /*#__PURE__*/_jsxs("div", {
          className: "vf-filter-wrap",
          children: [/*#__PURE__*/_jsx("input", {
            value: autocomplete,
            onChange: autocompleteSearchChange,
            className: "VF-form-control onchange-search form-control",
            id: 'select-' + label,
            name: label,
            placeholder: "Enter postcode, town or city",
            type: "text"
          }), !autocompleteListHide && autoCompleteFilter && Array.isArray(autoCompleteFilter) && autoCompleteFilter.length > 0 && /*#__PURE__*/_jsx("div", {
            className: "vf-filter-loc-complete-list",
            children: autoCompleteFilter.map(function (loc, i) {
              return /*#__PURE__*/_jsx("div", {
                onClick: function onClick() {
                  setAutocompleteListHide(true);
                  onLocationSelected(Object.assign({}, loc, {
                    distance: 10
                  }));
                },
                children: loc.displayName
              }, i);
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "filter-icon",
            children: [/*#__PURE__*/_jsx("span", {
              "aria-hidden": "true",
              onClick: function onClick() {
                return getCurrentLocation();
              },
              className: "far fa-dharmachakra right-icon " + (autocomplete && 'hidden') + " autocomplete-get-location",
              title: "Get your location"
            }), /*#__PURE__*/_jsx("span", {
              "aria-hidden": "true",
              onClick: function onClick() {
                setAutocompleteListHide(true);
                resetLocation();
              },
              className: "fas fa-undo right-icon " + (!autocomplete && 'hidden') + " autocomplete-get-location",
              title: "Reset Location"
            })]
          })]
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs("div", {
        className: "vf-filter",
        children: [/*#__PURE__*/_jsxs("label", {
          htmlFor: 'select-' + key,
          children: [label, ": "]
        }), /*#__PURE__*/_jsx("select", {
          className: "form-control",
          value: filters[key] || options[option][0],
          onChange: onSelectionChange,
          name: key,
          id: 'select-' + key,
          children: options[option].map(function (item, i) {
            return /*#__PURE__*/_jsx("option", {
              value: i === 0 ? 'All' : item,
              children: item
            }, i);
          })
        })]
      });
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "filters",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "page-search-input-group w-100",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-12 col-lg-6",
        children: renderFilter('Keyword Search', 'keywords', 'keywords')
      }), /*#__PURE__*/_jsx("div", {
        className: "col-12 col-lg-6",
        children: renderFilter('Location Search', 'autocomplete', 'autocomplete')
      })]
    }), siteConfig.showAdvancedFilters && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "page-search-input-group page-search-input-group-advanced w-100",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Posting Type', 'postingtype', 'postingTypes')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Location', 'location', 'locations')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Region', 'region', 'regions')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Industry', 'industrysector', 'industries')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Job Type', 'jobtype', 'jobTypes')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 col-lg-4",
          children: renderFilter('Filter by Category', 'category', 'categories')
        }), /*#__PURE__*/_jsx("div", {
          className: "col-12 mt-3",
          children: /*#__PURE__*/_jsx("button", {
            className: "btn btn-outline-danger float-right",
            onClick: function onClick() {
              return resetFilters();
            },
            children: "Reset Filters"
          })
        })]
      })
    })]
  });
};

export default SmartFeedFilters;